<div class="form-question-info">
  <i class="glicon-info color-deep-sky-blue font-normal cursor-pointer" (click)="onClick()"> </i>

  <div class="form-question-info-panel scale-transition scale-out z-depth-3" [ngClass]="{ 'scale-in': visible }">
    <div class="center-align">
      {{ message | translate }}
    </div>
  </div>
</div>
